import React, { useState } from 'react';
import { Card, Form, Input, Button, Typography, message } from 'antd';
import { authService, ChangePasswordRequest } from '../services/authService';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

const { Title } = Typography;

const ChangePassword: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [form] = Form.useForm();
  const navigate = useNavigate(); // Get the navigate function

  const handleSubmit = async (values: ChangePasswordRequest) => {
    setLoading(true);
    try {
      await authService.changePassword(values);
      message.success('Mật khẩu đã được thay đổi thành công!');
      navigate('/profile'); // Navigate to UserProfile after success
    } catch (error: any) {
      console.error('Failed to change password:', error);
      message.error(error.response?.data || 'Đổi mật khẩu thất bại.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card title={<Title level={4}>Đổi mật khẩu</Title>} style={{ maxWidth: 500, margin: '20px auto' }}>
      <Form
        form={form}
        name="changePassword"
        onFinish={handleSubmit}
        layout="vertical"
        requiredMark={false}
      >
        <Form.Item
          label="Mật khẩu hiện tại"
          name="currentPassword"
          rules={[{ required: true, message: 'Vui lòng nhập mật khẩu hiện tại!' }]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item
          label="Mật khẩu mới"
          name="newPassword"
          rules={[
            { required: true, message: 'Vui lòng nhập mật khẩu mới!' },
            { min: 6, message: 'Mật khẩu phải có ít nhất 6 ký tự!' },
          ]}
          hasFeedback
        >
          <Input.Password />
        </Form.Item>

        <Form.Item
          label="Xác nhận mật khẩu mới"
          name="confirmNewPassword"
          dependencies={['newPassword']}
          hasFeedback
          rules={[
            { required: true, message: 'Vui lòng xác nhận mật khẩu mới!' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('newPassword') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('Mật khẩu mới và xác nhận mật khẩu không khớp!'));
              },
            }),
          ]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} block>
            Đổi mật khẩu
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default ChangePassword;
